export function CountryBadge(props: { countryCode: string | null; additionalCount?: number }): React.JSX.Element {
  const code = props.countryCode;
  if (code === null) {
    return <span className="country-badge country-unknown">Unknown location</span>;
  }
  const additional = props.additionalCount ?? 0;
  return <span className="country-badge" title={formatCountryName(code)}>{countryFlag(code)} {formatCountryName(code)}{additional > 0 ? ` +${additional}` : ''}</span>;
}

export function SessionCountry(props: { countryCode: string | null; countryCodes: readonly string[] }): React.JSX.Element {
  const additionalCount = Math.max(0, props.countryCodes.length - (props.countryCode === null ? 0 : 1));
  return <CountryBadge countryCode={props.countryCode} additionalCount={additionalCount} />;
}

export function formatCountryName(countryCode: string): string {
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(countryCode) ?? countryCode;
  } catch {
    return countryCode;
  }
}

export function countryFlag(countryCode: string): string {
  if (!/^[A-Z]{2}$/.test(countryCode)) return '🌐';
  return String.fromCodePoint(...countryCode.split('').map(toRegionalIndicator));
}

function toRegionalIndicator(character: string): number {
  return 127397 + character.charCodeAt(0);
}
